import React from 'react';
import { Settings, TrendingUp, Target, Users, DollarSign, Lightbulb, Search, FileText, ArrowRight } from 'lucide-react';
import { services } from '../../data/mock';

const iconMap = {
  Settings,
  TrendingUp,
  Target,
  Users,
  DollarSign,
  Lightbulb,
  Search,
  FileText
};

const ServicesSection = ({ type }) => {
  const currentServices = type === 'industries' ? services.industries : services.innovation;
  const sectionTitle = type === 'industries' 
    ? 'Our Services' 
    : 'Innovation Funding Services';
  const sectionSubtitle = type === 'industries'
    ? 'Comprehensive consulting solutions to transform your business operations'
    : 'Maximise your innovation funding with our expert guidance';

  const images = {
    industries: [
      'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=600&q=80',
      'https://images.unsplash.com/39/lIZrwvbeRuuzqOoWJUEn_Photoaday_CSD%20%281%20of%201%29-5.jpg?auto=format&fit=crop&w=600&q=80',
      'https://images.pexels.com/photos/2977565/pexels-photo-2977565.jpeg?auto=compress&w=600',
      'https://images.unsplash.com/photo-1573757056004-065ad36e2cf4?auto=format&fit=crop&w=600&q=80'
    ],
    innovation: [
      'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=600&q=80',
      'https://images.pexels.com/photos/3861458/pexels-photo-3861458.jpeg?auto=compress&w=600',
      'https://images.unsplash.com/photo-1573757056004-065ad36e2cf4?auto=format&fit=crop&w=600&q=80',
      'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=600&q=80'
    ]
  };

  return (
    <section id={type === 'industries' ? 'services' : 'sred-basics'} className="relative bg-black py-24 lg:py-32 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-[0.02]">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(74, 144, 164, 0.5) 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }} />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <span className="text-[#4A90A4] text-sm font-semibold uppercase tracking-wider mb-4 block">What We Do</span>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              {sectionTitle}
            </h2>
            <p className="text-white/60 text-lg">
              {sectionSubtitle}
            </p>
          </div>
          <a
            href="#contact"
            className="group inline-flex items-center gap-2 text-[#4A90A4] hover:text-white transition-colors duration-300"
          >
            View All Services
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform duration-300" />
          </a>
        </div>

        {/* Services Grid with Images */}
        <div className="grid lg:grid-cols-2 gap-8">
          {currentServices.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={index}
                className="group relative bg-white/[0.02] border border-white/10 hover:border-[#4A90A4]/50 transition-all duration-500 overflow-hidden"
              >
                {/* Service Image */}
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={images[type][index]} 
                    alt={service.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
                  <div className="absolute bottom-4 left-4">
                    <div className="w-12 h-12 bg-[#4A90A4] flex items-center justify-center">
                      {IconComponent && <IconComponent size={24} className="text-white" />}
                    </div>
                  </div>
                </div>

                {/* Service Content */}
                <div className="p-6 lg:p-8">
                  <h3 className="text-xl font-semibold text-white mb-3 group-hover:text-[#4A90A4] transition-colors duration-300">
                    {service.title}
                  </h3>
                  <p className="text-white/60 leading-relaxed mb-4">
                    {service.description}
                  </p>
                  <a 
                    href="#contact" 
                    className="inline-flex items-center gap-2 text-[#4A90A4] text-sm font-medium hover:gap-3 transition-all duration-300"
                  >
                    Learn More <ArrowRight size={14} />
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
